import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

const GridCard = styled(Card)(() => ({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  width: "100%",
  boxShadow: "6px rgb(0 0 0 / 4%)",
}));

export default GridCard;
